import {LinearProgress} from "@mui/material";
import {FC, useContext, useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {AuthContext} from "@buildwitt/shapeshift-identity";
import useDevCycleSdk from "@/hooks/useDevCycleSdk";

export const LoginPage: FC = () => {
	const {authenticated} = useContext(AuthContext);
	const navigate = useNavigate();
	const {newHomeScreen} = useDevCycleSdk();

	useEffect(() => {
		if(authenticated === true) {
			navigate(newHomeScreen ? "/home" : "/training-feed")
		}
	}, [authenticated])

	return <LinearProgress />
}